<div>
  <div class="flex items-center justify-center h-[70px]">
    <h4 class="xl:text-xl lg:text-lg text-primary text-lg font-medium font-sans font-medium"> Format Title </h4>
  </div>
  <mat-dialog-content class="!pt-0">
    <div class="item-required-warning text-xs" style="display: none;"><i class="fas fa-exclamation-triangle text-red pr-2"></i> Please select atleast one item from the list to build title</div>
    <div class="flex gap-6">
      <!-- Available list -->
      <div cdkDropList
        [cdkDropListData]="items"
        [cdkDropListConnectedTo]="['chipList']"
        (cdkDropListDropped)="drop($event)"
        class="p-2 border rounded w-1/2 bg-gray-50">
        <h4 class="font-semibold text-xs mb-2">Available Items</h4>
        @for (item of items; track item) {
          <div cdkDrag
            class="p-1 pl-2 my-1 bg-white border rounded cursor-move shadow-sm !text-[11px] whitespace-nowrap overflow-hidden text-ellipsis">
            {{ item.caption }}
          </div>
        }
      </div>

      <!-- Selected Set -->
      <div cdkDropList
        #chipList="cdkDropList" id="chipList"
        [cdkDropListData]="selectedItems"
        [cdkDropListConnectedTo]="['sourceList']"
        (cdkDropListDropped)="drop($event)"
        class="p-2 border rounded w-1/2 bg-gray-50">
        <h3 class="font-semibold text-xs mb-2">Selected items</h3>
        <mat-chip-set>
          @for (item of selectedItems; track item; let i = $index) {
            <mat-chip class="!h-[28px]" (removed)="removeItem(i)" cdkDrag removable>
              <div class="!text-[11px]">{{ item.caption }}
                <button matChipRemove aria-label="Remove chip" class="!text-[11px]">✕</button>
              </div>
            </mat-chip>
          }
        </mat-chip-set>
      </div>
    </div>

    <!-- Submit Button -->
    <mat-dialog-actions class="!px-0 flex !justify-center !pt-5">
      <button mat-flat-button mat-dialog-close color="accent" class="text-primary secondary-button">Cancel</button>
      <button mat-flat-button class="text-primary primary-button" (click)="onSubmit()">Set Title</button>
    </mat-dialog-actions>
  </mat-dialog-content>
</div>